// Max content width for the wizard's step body, per the Figma layout. Shared so
// the Testing stage, the Locations stage, and the activation-cue wrapper don't
// drift on independent magic numbers (AI-160 review). Now a re-export of the
// scene-wide constant so the Settings panes share the same value; the wizard
// keeps its own name for its existing importers.
export { RECOVERY_AI_CONTENT_MAX_WIDTH as WIZARD_CONTENT_MAX_WIDTH } from '../components/layout'

// z-index shared by the wizard's sticky header + playback bars, and the app
// navbar height the sticky header offsets by (AI-1123). Re-exported here as the
// wizard-facing entry point (like WIZARD_CONTENT_MAX_WIDTH above), so Wizard/
// files import from './constants'. Sandbox/ files (e.g. WizardSimulator) import
// straight from '../components/layout' to avoid a Sandbox→Wizard dependency.
export {
  APP_NAVBAR_HEIGHT,
  WIZARD_STICKY_BAR_Z_INDEX,
} from '../components/layout'

// Shared RTK Query mutation cache keys for the Escalations stage's eager writes.
// The step FIRES them; useActivationCompleteness — which runs in the wizard
// SHELL, outside the step's tree — OBSERVES them to keep Finalize disabled while
// a recipient/notify write is in flight or has failed.
//
//   context: both sites must import these constants, never inline a literal — a
//   typo at either end is NOT benign. Detaching the CONFIG observer leaves
//   isSavingNotify false forever, so a notify-OFF write in flight sits at the
//   notify leg with the cache still reading `true` and Finalize ENABLED: the
//   merchant activates with no reachable human. Measured under both rung orders,
//   so the ladder's shape does not save it.
//
//   The guard is EXECUTABLE, so don't reason about it — run it.
//   useActivationCompleteness.mutationCable.test.ts drives both hooks over one real
//   store against msw: severing the notify key fails one of its three cases,
//   severing the contacts key fails the other two (measured). No other wizard suite
//   can see it — they module-mock the api and hand both sides the same tuple — so
//   that file is load-bearing, not redundant coverage.
export const ESCALATION_CONTACTS_SAVE_KEY = 'wizard-escalation-contacts'
export const ESCALATION_NOTIFY_SAVE_KEY = 'wizard-escalation-notify'
